import * as CoreUI from "@coreui/coreui-pro";

const initializeCoreUI = () => {
  document.querySelectorAll(".sidebar").forEach((element) => {
    CoreUI.Sidebar.getOrCreateInstance(element);
  });

  document.querySelectorAll('[data-coreui="navigation"], [data-coreui-navigation]').forEach((element) => {
    CoreUI.Navigation.getOrCreateInstance(element);
  });

  document.querySelectorAll('[data-coreui-toggle="tooltip"]').forEach((element) => {
    CoreUI.Tooltip.getOrCreateInstance(element);
  });

  document.querySelectorAll('[data-coreui-toggle="popover"]').forEach((element) => {
    CoreUI.Popover.getOrCreateInstance(element);
  });
};

// Turbo replaces the body but retains the html element. Synchronize the root
// before rendering so native controls and DataTables receive the saved mode.
document.addEventListener("turbo:before-render", (event) => {
  const theme = event.detail.newBody.dataset.coreuiTheme || "light";
  document.documentElement.dataset.coreuiTheme = theme;
  document.documentElement.dataset.bsTheme = theme;
});

document.addEventListener("turbo:load", initializeCoreUI);
document.addEventListener("turbo:frame-load", initializeCoreUI);

// CoreUI 5 only handles narrow/unfoldable toggles inside the sidebar itself.
// Keep the application's external sidebar and aside buttons working.
document.addEventListener("click", (event) => {
  const toggle = event.target.closest('[data-coreui-toggle="sidebar"]');
  if (!toggle) return;

  const sidebar = document.querySelector(toggle.dataset.coreuiTarget);
  if (!sidebar) return;

  event.preventDefault();
  CoreUI.Sidebar.getOrCreateInstance(sidebar).toggle();
});

document.addEventListener("turbo:before-cache", () => {
  [
    ['[data-coreui-toggle="tooltip"]', CoreUI.Tooltip],
    ['[data-coreui-toggle="popover"]', CoreUI.Popover],
    ['[data-coreui-toggle="dropdown"]', CoreUI.Dropdown]
  ].forEach(([selector, Component]) => {
    document.querySelectorAll(selector).forEach((element) => {
      const instance = Component.getInstance(element);
      // Tooltips/popovers dispose their Popper directly. Calling hide first
      // would leave a transition callback pointing at the disposed instance.
      if (Component === CoreUI.Dropdown) instance?.hide();
      instance?.dispose();
      if (Component !== CoreUI.Dropdown) element.removeAttribute("aria-describedby");
    });
  });
});
